import axios from "utils/axios";
import { stringify } from "query-string";

export const getPettyCashPagination = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/pettycash/pagination?${query}`);
};

export const getPettyCash = (id) => {
  return axios.get(`/hr/pettycash/${id}`);
};

export const addPettyCash = (data) => {
  return axios.post(`/hr/pettycash`, data);
};

export const editPettyCash = (data) => {
  return axios.put(`/hr/pettycash/${data?.id}`, data);
};

export const updateReportPettyCash = (data) => {
  return axios.put(`/hr/pettycash/${data?.id}/updateReport`, data);
};

export const updateCompleteReportPettyCash = (data) => {
  return axios.put(`/hr/pettycash/${data?.id}/completeReport`, data);
};

export const updateUncompleteReportPettyCash = (id) => {
  return axios.put(`/hr/pettycash/${id}/uncompleteReport`);
};

export const declinePettyCash = (id) => {
  return axios.put(`/hr/pettycash/${id}/decline`);
};

export const cancelPettyCash = (id) => {
  return axios.put(`/hr/pettycash/${id}/cancel`);
};

export const verifyPettyCash = (id) => {
  return axios.put(`/hr/pettycash/${id}/verify`);
};

export const deletePettyCash = (id) => {
  return axios.delete(`/hr/pettycash/${id}`);
};

export const deleteAttachmentPettyCash = (data) => {
  return axios.delete(
    `/hr/pettycash/${data?.pettyCashId}/attachment/delete/${data?.id}`
  );
};
